import {
  GET_ARCHIVES, STOP_LOADING,
  START_LOADING
} from "../archiveAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_ARCHIVES:
      return {
        ...state,
        archive_data: action.payload,
        success: false,
        loading: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}